module.exports = __webpack_public_path__ + "static/media/EUROSP.58c704ce.svg";